export default {
  gameData: [
    {
      category: "Animated Characters",
      prompt: [
        "Garfield",
        "Scooby-Doo",
        "Bugs Bunny",
        "Mickey Mouse",
        "Dumbo",
        "Nemo",
        "Snoopy",
        "Simba",
        "Bambi",
        "Goofy",
        "Top Cat",
        "Tom and Jerry",
        "Donald Duck",
        "Shrek",
        "Porky Pig",
      ],
    },
    {
      category: "Bands",
      prompt: [
        "The Beatles",
        "Backstreet Boys",
        "Spice Girls",
        "ABBA",
        "The Rolling Stones",
        "One Direction",
        "Red Hot Chili Peppers",
        "Girls Aloud",
        "U2",
        "Queen",
        "Coldplay",
        "Nirvana",
        "Jackson 5",
        "Green Day",
        "The Killers",
      ],
    },
    {
      category: "Capital Cities",
      prompt: [
        "Athens",
        "Baghdad",
        "London",
        "Stockholm",
        "Madrid",
        "Dublin",
        "Jerusalem",
        "Kuala Lumpur",
        "Cairo",
        "Buenos Aires",
        "Washington DC",
        "Tokyo",
        "Beijing",
        "Tehran",
        "Warsaw",
      ],
    },
    {
      category: "Countries",
      prompt: [
        "United Kingdom",
        "Cuba",
        "France",
        "Iraq",
        "China",
        "Russia",
        "United States",
        "Brazil",
        "Japan",
        "India",
        "Nigeria",
        "Egypt",
        "Germany",
        "Australia",
        "Israel",
      ],
    },
    {
      category: "Fictional Characters",
      prompt: [
        "Indiana Jones",
        "Popeye",
        "Spiderman",
        "Darth Vader",
        "Sherlock Holmes",
        "Gandalf",
        "Superman",
        "Batman",
        "James Bond",
        "Dracula",
        "Homer Simpson",
        "Frankenstein",
        "Robin Hood",
        "Super Mario",
        "Tarzan",
      ],
    },
    {
      category: "Film Genres",
      prompt: [
        "Horror",
        "Action",
        "Sci-Fi",
        "Romance",
        "Western",
        "Christmas",
        "War",
        "Musical",
        "Adventure",
        "Animation",
        "Documentary",
        "Silent",
        "Superhero",
        "Comedy",
        "Noir",
      ],
    },
    {
      category: "Food",
      prompt: [
        "Pizza",
        "Fruit",
        "Bread",
        "Yoghurt",
        "Fish",
        "Curry",
        "Pasta",
        "Chicken",
        "Cake",
        "Beef",
        "Sausage",
        "Salad",
        "Soup",
        "Chocolate",
        "Cheese",
      ],
    },
    {
      category: "Games",
      prompt: [
        "Monopoly",
        "Scrabble",
        "Mouse Trap",
        "Guess Who",
        "Risk",
        "Operation",
        "Twister",
        "Battleships",
        "Backgammon",
        "Chess",
        "Checkers",
        "Trivial Pursuit",
        "Jenga",
        "Hungry Hungry Hippos",
        "Poker",
      ],
    },
    {
      category: "Geography",
      prompt: [
        "Lake",
        "Sea",
        "Valley",
        "Mountain",
        "River",
        "Desert",
        "Ocean",
        "Forest",
        "Jungle",
        "Glacier",
        "Waterfall",
        "Volcano",
        "Cave",
        "Arctic",
        "Swamp",
      ],
    },
    {
      category: "Historical Figures",
      prompt: [
        "Napoleon",
        "Stalin",
        "Charles Darwin",
        "Einstein",
        "Mozart",
        "Julius Caesar",
        "Churchill",
        "Christopher Columbus",
        "Nelson Mandela",
        "Florence Nightingale",
        "JFK",
        "Mao",
        "Neil Armstrong",
        "Cleopatra",
        "Queen Victoria",
      ],
    },
    {
      category: "Inventions",
      prompt: [
        "Matches",
        "Gunpowder",
        "Wheel",
        "Printing",
        "Computer",
        "Internet",
        "Compass",
        "Plane",
        "TV",
        "Electricity",
        "Writing",
        "Steam Engine",
        "Car",
        "Telephone",
        "Radio",
      ],
    },
    {
      category: "Jobs",
      prompt: [
        "Fisherman",
        "Lumberjack",
        "Nurse",
        "Waiter",
        "Lighthouse Keeper",
        "Secretary",
        "Accountant",
        "Teacher",
        "Lorry Driver",
        "Security Guard",
        "Chef",
        "Architect",
        "Police Officer",
        "Lawyer",
        "Butcher",
      ],
    },
    {
      category: "Musical Instruments",
      prompt: [
        "Piano",
        "Triangle",
        "Trumpet",
        "Church Organ",
        "Violin",
        "Trombone",
        "Flute",
        "Drums",
        "Saxophone",
        "Guitar",
        "Harmonica",
        "Clarinet",
        "Xylophone",
        "Cello",
        "Kazoo",
      ],
    },
    {
      category: "Movies",
      prompt: [
        "Jurassic Park",
        "Jaws",
        "Iron Man",
        "Transformers",
        "Toy Story",
        "Home Alone",
        "Titanic",
        "E.T.",
        "Inception",
        "King Kong",
        "The Matrix",
        "Avatar",
        "Harry Potter",
        "Fast and Furious",
        "Indiana Jones",
      ],
    },
    {
      category: "Mythical Creatures",
      prompt: [
        "Cyclops",
        "Pegasus",
        "Medusa",
        "Sphinx",
        "Werewolf",
        "Unicorn",
        "Dragon",
        "Troll",
        "Loch Ness Monster",
        "Mermaid",
        "Vampire",
        "Minotaur",
        "Yeti",
        "Gargoyle",
        "Centaur",
      ],
    },
    {
      category: "Phobias",
      prompt: [
        "Ghosts",
        "Spiders",
        "Rats",
        "Snakes",
        "Needles",
        "Clowns",
        "Blood",
        "Flying",
        "Dogs",
        "Roller Coasters",
        "Germs",
        "Heights",
        "Enclosed spaces",
        "Birds",
        "Strangers",
      ],
    },
    {
      category: "Sea life",
      prompt: [
        "Octopus",
        "Starfish",
        "Shark",
        "Jellyfish",
        "Lobster",
        "Seal",
        "Dolphin",
        "Killer Whale",
        "Crab",
        "Giant Squid",
        "Seahorse",
        "Stingray",
        "Mermaid",
        "Sea Turtle",
        "Clownfish",
      ],
    },
    {
      category: "Sports",
      prompt: [
        "Football",
        "Tennis",
        "Cricket",
        "Archery",
        "Rugby",
        "Swimming",
        "Sailing",
        "Darts",
        "Snooker",
        "Beer Pong",
        "Gymnastics",
        "Cycling",
        "Bowling",
        "Volleyball",
        "Badminton",
      ],
    },
    {
      category: "Toys",
      prompt: [
        "Lego",
        "Rocking Horse",
        "Super Soaker",
        "Rubik's Cube",
        "Etch a Sketch",
        "Teddy Bear",
        "Play Doh",
        "Yo-yo",
        "Frisbee",
        "Barbie",
        "Slinky",
        "Action Man",
        "Hula Hoop",
        "Furby",
        "Tamagotchi",
      ],
    },
    {
      category: "Transport",
      prompt: [
        "Plane",
        "Car",
        "Tank",
        "Helicopter",
        "Cruise Ship",
        "Hovercraft",
        "Motorbike",
        "Bus",
        "Segway",
        "Jet Ski",
        "Hot Air Balloon",
        "Train",
        "Spaceship",
        "Magic Carpet",
        "Broomstick",
      ],
    },
    {
      category: "TV Shows",
      prompt: [
        "Friends",
        "Breaking Bad",
        "EastEnders",
        "The Office",
        "The Simpsons",
        "Star Trek",
        "Little Britain",
        "Fawlty Towers",
        "Blackadder",
        "Game of Thrones",
        "Scrubs",
        "Family Guy",
        "Doctor Who",
        "Teletubbies",
        "Stranger Things",
      ],
    },
    {
      category: "Video Game Characters",
      prompt: [
        "Lara Croft",
        "Mario",
        "Pacman",
        "Solid Snake",
        "Gordon Freeman",
        "Princess Zelda",
        "Master Chief",
        "Bowser",
        "Crash Bandicoot",
        "Donkey Kong",
        "Doomguy",
        "Sonic",
        "Shodan",
        "Spyro",
        "Mega Man",
      ],
    },
    {
      category: "Zoo Animals",
      prompt: [
        "Lion",
        "Elephant",
        "Gorilla",
        "Rhino",
        "Zebra",
        "Crocodile",
        "Parrot",
        "Meerkat",
        "Tortoise",
        "Tapir",
        "Frog",
        "Tarantula",
        "Snake",
        "Scorpion",
        "Giraffe",
      ],
    },
  ],
};
